<template>
  <div>
    <v-tabs
      fixed-tabs
      grow
      slider-color="primary"
    >
      <v-tab href="#institucion" >
        <span>Institución</span>
      </v-tab>
      <v-tab href="#titulos" >
        <span>Títulos</span>
      </v-tab>
      <v-tab href="#certificados" >
        <span>Certificados</span>
      </v-tab>

      <v-tabs-items>
        <v-tab-item value="institucion">
          <v-container fluid grid-list-xl>
            <v-layout row justify-center wrap>
              <v-flex lg6 sm9 xs12>
                <transition name="fade" mode="out-in">
                  <div>
                    <v-text-field
                      :label="labels.nombre"
                      v-model="institucion.nombre"
                      @click:append="editarInstitucion('nombre')"
                      append-icon="edit"
                      outline
                      readonly
                    ></v-text-field>

                    <v-text-field
                      :label="labels.clave_dgp"
                      v-model="institucion.clave"
                      @click:append="editarInstitucion('clave_dgp')"
                      append-icon="edit"
                      outline
                      readonly
                    ></v-text-field>

                    <v-text-field
                      :label="labels.clave_concentradora"
                      v-model="institucion.clave_concentradora"
                      @click:append="editarInstitucion('clave_concentradora')"
                      append-icon="edit"
                      outline
                      readonly
                    ></v-text-field>
                  </div>
               </transition>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>

        <v-tab-item value="titulos">
          <v-container fluid grid-list-xl>
            <v-layout row justify-center wrap>
              <v-flex lg6 sm9 xs12>
                <transition name="fade" mode="out-in">
                  <div>
                    <v-text-field
                      :label="labels.version_xml_titulos"
                      v-model="institucion.configuracion.version_xml_titulos"
                      @click:append="editarInstitucion('version_xml_titulos')"
                      append-icon="edit"
                      outline
                      readonly
                    ></v-text-field>

                    <v-text-field
                      :label="labels.consecutivo_titulos"
                      v-model="institucion.configuracion.consecutivo_titulos"
                      outline
                      readonly
                    ></v-text-field>

                    <v-text-field
                      :label="labels.consecutivo_lote_titulos"
                      v-model="institucion.configuracion.consecutivo_lote_titulos"
                      outline
                      readonly
                    ></v-text-field>

                    <v-text-field
                      :label="labels.wsdl_url_titulos"
                      v-model="institucion.configuracion.wsdl_url_titulos"
                      @click:append="editarInstitucion('wsdl_url_titulos')"
                      append-icon="edit"
                      outline
                      readonly
                    ></v-text-field>

                    <v-text-field
                      :label="labels.wsdl_usuario_titulos"
                      v-model="institucion.configuracion.wsdl_usuario_titulos"
                      @click:append="editarInstitucion('wsdl_usuario_titulos')"
                      append-icon="edit"
                      outline
                      readonly
                    ></v-text-field>

                    <v-text-field
                      :label="labels.wsdl_constrasena_titulos"
                      v-model="institucion.configuracion.wsdl_constrasena_titulos"
                      @click:append="editarInstitucion('wsdl_constrasena_titulos')"
                      append-icon="edit"
                      outline
                      readonly
                    ></v-text-field>
                  </div>
                </transition>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>

        <v-tab-item value="certificados">
          <v-container fluid grid-list-xl>
            <v-layout row justify-center wrap>
              <v-flex lg6 sm9 xs12>
                <transition name="fade" mode="out-in">
                  <div>
                    <v-text-field
                      :label="labels.version_xml_certificados"
                      v-model="institucion.configuracion.version_xml_certificados"
                      @click:append="editarInstitucion('version_xml_certificados')"
                      append-icon="edit"
                      outline
                      readonly
                    ></v-text-field>

                    <v-text-field
                      :label="labels.consecutivo_certificados"
                      v-model="institucion.configuracion.consecutivo_certificados"
                      outline
                      readonly
                    ></v-text-field>

                    <v-text-field
                      :label="labels.consecutivo_lote_certificados"
                      v-model="institucion.configuracion.consecutivo_lote_certificados"
                      outline
                      readonly
                    ></v-text-field>
                  </div>
                </transition>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { api } from "~/config";
import Form from '~/mixins/form'

export default {
  mixins: [Form],

  data: () => ({
    passwordHidden: true,
    
    institucion: {
      configuracion: {}
    }
  }),

  computed: {
    ...mapGetters({
      live_mode: "auth/live_mode",
    })
  },

  watch: {
    live_mode(val) {
      if (val !== undefined) {
        this.$router.push({ name: 'configuracion' })
         this.getInstitucion(1)
      }
    }
  },

  methods: {
    getInstitucion(id) {
      axios
        .get(api.path('instituciones.single', { id: id }))
        .then(res => {
          this.institucion = res.data
        })
        .catch(err => {
          this.handleErrors(err.response.data.errors)
        })
        .then(() => {})
    },

    editarInstitucion(campo) {
      this.$router.push({ name: "configuracion-editar", params: { 'campo': campo } })
    }
  },

  mounted() {
    this.getInstitucion(1)
  }
}
</script>
